import React, { useEffect } from "react";
import FormComp from "../shared/FormComp/FormComp";
import Layout from "../shared/Layout/Layout";
import PageIntro from "../shared/PageIntro/PageIntro";
import ContactDetails from "./ContactDetails";
import VideoSection from "./VideoSection";

function Contact() {
  useEffect(() => {
    document.title = "Contact - MetaWorldX";
  }, []);

  return (
    <Layout>
      <div className="mt-[60px]">
        <PageIntro headingOne="Contact Us" headingTwo={"Home > Contact Us"} />
        <div>
          <div className="text-[34px] text-[#ffffff] font-semibold text-center max-[481px]:text-[18px] mt-8">
            Our digital experience specialists will answer your questions and
            show you what we do.
          </div>
          <FormComp />
        </div>
        <ContactDetails />
        <VideoSection />
      </div>
    </Layout>
  );
}

export default Contact;
